import {Component} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {EnvironmentService} from '../../services/environment.service';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import {AffiliateInvoice} from '../../models/affiliate-invoice';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

declare var $: any;
declare var Snackbar: any;

@Component({
  selector: 'app-affiliate-invoices',
  templateUrl: './affiliate-invoices.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrl: './affiliate-invoices.component.scss'
})
export class AffiliateInvoicesComponent {

  constructor(private loader: GlobalLoaderService,
              public env: EnvironmentService,
              private translator: TranslateService,
              private route: ActivatedRoute,
              private api: ApiAgentService) {
  }

  invoices: AffiliateInvoice[];
  subAccountType: any;
  subAccountGovId: any;
  loading: any;
  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;

  // Add pagination properties
  totalItems: number;
  totalPages: number;
  currentPage: number;

  lang: string;

  static compare(a: any, b: any) {
    if (a.id < b.id) {
      return -1;
    }
    if (a.id > b.id) {
      return 1;
    }
    return 0;
  }

  checkPermission() {
    this.route.queryParams.subscribe(params => {
      console.log('Params: ', params);
      let perms = this.env.checkPermission(params['type'], params['govId']);
      this.isAccountant = perms.isAccountant;
      this.isSales = perms.isSales;
      this.isMerchant = perms.isMerchant;
      this.isManager = perms.isManager;
      console.log('Permissions: ', perms);
    });
  }

  async ngOnInit() {
    this.loading = true;
    this.lang = await firstValueFrom(this.translator.get('lang'));
    await this.loadResources();
    await this.loadData();
    console.log('Data loaded');
    this.loading = false;
    this.checkPermission();
    console.log('Permissions checked');
  }

  async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
  }

  // private async loadData() {
  //   let data = await this.api.getAffiliateInvoices();
  //   console.log('Data: ', data);
  //   this.invoices = data.affiliateInvoices;
  //   this.invoices.sort(AffiliateInvoicesComponent.compare);
  //   console.log('Invoices: ', this.invoices);
  // }

  public async loadData(page = 0, size = 20, sort = 'create_date,desc') {
    try {
      this.loading = true; // Show loading indicator
      const response = await this.api.getAffiliateInvoices(page, size, sort);
      console.log('Response data: ', response);

      if (response && response.affiliateInvoices) {
        this.invoices = response.affiliateInvoices.content;
        this.totalItems = response.affiliateInvoices.totalElements;
        this.totalPages = response.affiliateInvoices.totalPages;
        this.currentPage = response.affiliateInvoices.number;
      } else {
        this.invoices = [];
        console.error('Unexpected response structure:', response);
      }

      console.log('Invoices: ', this.invoices);
    } catch (error) {
      console.error('Error loading affiliate invoices:', error);
      this.invoices = [];
    } finally {
      this.loading = false; // Hide loading indicator when done
    }
  }
}
